import { Typography, Icon } from '@material-ui/core';
import clsx from 'clsx';

function EditFormSeparatorField(props) {
	return (
		<div className={props.fieldConfig.className ? props.fieldConfig.className : 'pb-16'}>
			<div className="flex items-center">
				{props.fieldConfig.icon ? <Icon color="action">{props.fieldConfig.icon}</Icon> : null}
				<Typography className="h2 mx-10 font-medium" color="textSecondary">
					{props.fieldConfig.text}
				</Typography>
			</div>
		</div>
	);
}

export default EditFormSeparatorField;
